import { Badge } from "@altimateai/lego";
import styles from "./styles.module.scss";
import { getMoneySavings } from "@/pages/explorer/utils";
import { useAppState } from "@/modules/app/useAppContext";

export const MoneySavingsTag = ({
  savings = {
    min: "0",
    max: "0",
  },
}) => {
  const { currency } = useAppState();
  return (
    <Badge variant="success" className={styles.moneySavings}>
      {getMoneySavings(savings.min, savings.max, currency)}
    </Badge>
  );
};

export const TimeSavingsTag = ({ savings = "0" }) => {
  return (
    <Badge variant="warning" className={styles.timeSavings}>
      {savings}
    </Badge>
  );
};

export const CountTag = ({ count = 0 }) => {
  return <Badge variant="warning">Count: {count}</Badge>;
};

export const LinenumberTag = ({ linenumber }: { linenumber: string }) => {
  return <Badge variant="warning">{linenumber}</Badge>;
};
